import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { ProtocoloAtendimentoTipo } from './protocolo-atendimento-tipo.model';
import { NTECH_API } from '../app.api';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-protocolo-atendimento-tipo',
  templateUrl: './protocolo-atendimento-tipo.component.html',
  styleUrls: ['./protocolo-atendimento-tipo.component.css']
})
export class ProtocoloAtendimentoTipoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  listaProtocoloAtendimentoTipo: CustomStore;
  alturaGrid = null;
  colunasGridProtocoloAtendimentoTipo = [];

  editOptionsGridProtocoloAtendimentoTipo = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Procotolo Atendimento Tipo',
      showTitle: true
    }
  };

  constructor( @Inject(Http) http: Http) {
    this.listaProtocoloAtendimentoTipo = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/protocolo-atendimento-tipo/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/protocolo-atendimento-tipo/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/protocolo-atendimento-tipo/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/protocolo-atendimento-tipo/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
    this.colunasGridProtocoloAtendimentoTipo = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'DescricaoAtendimentoTipo',
        dataType: 'string',
        caption: 'Descrição',
        validationRules: [{
          type: 'required',
          message: 'Descrição é obrigatório.'
        }]
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/protocolo-atendimento-tipo/protocolo-atendimento-tipo.component.ts